export default __webpack_public_path__ + "static/media/notes.af12dbe5.svg";